import { GetStaticPaths, GetStaticProps } from 'next';
import ArticleCategoryPage, {
  getCategoryPageStaticProps,
} from '../../../../../../pageHelpers/articles/categoryPage';
import { getPlaiceholder } from 'plaiceholder';
import convertImageUrlToS3ImageUrl from '../../../../../../helpers/convertImageUrlToS3ImageUrl';
import getGameSlugs from '../../../../../../helpers/getGameSlugs';
import getArticleCategories from '../../../../../../helpers/getArticleCategories';
import getArticleSlugs from '../../../../../../helpers/getArticleSlugs';

export const ArticleCategoryPageNumberPath =
  '/[gameSlug]/articles/[articleCategorySlug]/page/[pageNumber]';

// Keep this in sync with PageOfArticlePreviewsViewModelBuilder.php
export const articleCategoryPageSize = 10;

export default ArticleCategoryPage;

export const getStaticPaths: GetStaticPaths = async () => {
  const gameSlugs = await getGameSlugs();
  const articleCategorySlugs = (await getArticleCategories()).map(
    (x) => x.slug
  );

  const paths = (
    await Promise.all(
      gameSlugs.flatMap(async (gameSlug) =>
        (
          await Promise.all(
            articleCategorySlugs.flatMap(async (articleCategorySlug) => {
              const articleSlugs = await getArticleSlugs(
                articleCategorySlug,
                gameSlug
              );
              const numberOfPages = Math.ceil(
                articleSlugs.length / articleCategoryPageSize
              );

              return Array(numberOfPages)
                .fill(0)
                .map((_, index) => index + 1)
                .map((pageNumber) => ({
                  params: {
                    gameSlug,
                    articleCategorySlug,
                    pageNumber: pageNumber.toString(),
                  },
                }));
            })
          )
        )
          .flat()
          .flat()
      )
    )
  ).flat();

  return {
    paths,
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = getCategoryPageStaticProps(
  async (src: string) => await getPlaiceholder(convertImageUrlToS3ImageUrl(src))
);
